import React, { createContext, useState, Fragment, useContext, useEffect } from 'react';
import { CustomModal } from '../../components/modal/modalBase';
import { CloseButton } from '../../components';
export const BaseModalContext = createContext();

export const BaseModalProvider = ({ children }) => {
    const [activeModal, setActiveModal] = useState('');
    const [params, setParams] = useState({});
    const [styles, setStyles] = useState({});

    return (
        <Fragment>
            <BaseModalContext.Provider
                value={{
                    activeModal,
                    setActiveModal,
                    params,
                    setParams,
                    setStyles,
                    styles,
                }}
            >
                {children}
            </BaseModalContext.Provider>
        </Fragment>
    );
};

export const useBaseModal = () => {
    const { setActiveModal, params, setParams, styles, setStyles } = useContext(BaseModalContext);

    return {
        openBase: (params = {}, styles) => {
            setActiveModal(true);
            setParams(params);
            setStyles(styles);
        },
        closeBase: () => {
            setActiveModal('');
            setParams({});
            setStyles({});
        },
        params,
        styles,
    };
};

export const BaseModals = () => {
    const { activeModal } = useContext(BaseModalContext);
    const { closeBase, params, styles } = useBaseModal();

    useEffect(() => {
        if (activeModal) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
    }, [activeModal]);

    return (
        <CustomModal
            handleOpenClose={closeBase}
            openDefault={activeModal ? activeModal : false}
            content={
                <div style={{ outline: 'none', ...styles?.styles?.wrapperStyle }} className="modal-wrapper-style open-sans">
                    <div className="modal-header-style" style={{ ...styles?.styles?.headerStyle }}>
                        <CloseButton handleCLic={closeBase} />
                    </div>
                    <div style={styles?.styles?.bodyStyle ? { ...styles?.styles?.bodyStyle } : {}} className="modal-body-style-small">
                        {params}
                    </div>
                </div>
            }
        />
    );
};
